
import { APP_INITIALIZER, Provider, DOCUMENT } from '@angular/core';

/**
 * Loads the standard gtag.js snippet for the given measurement id.
 * Replaces NgxGoogleAnalyticsModule.forRoot(), which only sent the initial page view.
 * Nothing is loaded when the id is empty (all environments except production).
 */
export function provideGoogleAnalytics(measurementId: string): Provider {
  return {
    provide: APP_INITIALIZER,
    multi: true,
    deps: [DOCUMENT],
    useFactory: (document: Document) => () => {
      if (!measurementId) {
        return;
      }
      const w = window as any;
      w.dataLayer = w.dataLayer || [];
      w.gtag =
        w.gtag ||
        function () {
          w.dataLayer.push(arguments);
        };
      w.gtag('js', new Date());
      w.gtag('config', measurementId);

      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      document.getElementsByTagName('head')[0].appendChild(script);
    },
  };
}
